import React from 'react';
import Copyright from 'common/Copyright';
import { LoginButton } from './Auth';
import { useLocation } from 'react-router';
import logo from '../assets/ezrespond-logo.svg';
import './SignIn.css';
import { Redirect, useHistory } from 'react-router-dom';
import { useAuth } from 'common/auth';

export default function SignIn() {
  let auth = useAuth();
  const history = useHistory();

  let location = useLocation();
  let { from } = location.state || { from: { pathname: '/' } };
  const login = resp => auth.signIn(resp, () => history.replace(from));

  if (auth.user) {
    return <Redirect to="/settings" />;
  }

  return (
      <div className="signin-container">
        <div className="signin-content">
          <div className="signin-header">
            <a href="https://ezrespond.com/">
              <img src={logo} alt="EzRespond" className="signin-app-logo" />
            </a>
            <h2 className="">Welcome to EzRespond</h2>
            <p className="signin-text">Smart auto-responder for your Gmail</p>
          </div>
          <main className="public-main">
          </main>

          <div className="signin-auth">
            <p className="signin-text-2">To get started, sign in with your Google account</p>
            <LoginButton onSuccess={login} />
            {/* Prominent disclosure next to the Google consent request —
                see GOOGLE_OAUTH_VERIFICATION.md 1.4. */}
            <p className="signin-notice">
              Signing in shares only your name and email address with EzRespond.
              Gmail access is requested separately in Settings, where we explain
              what EzRespond reads, sends and stores before Google asks for your
              consent. We never store email bodies.{' '}
              <a
                href="https://ezrespond.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </p>
          </div>

          <div className="signin-privacy">
            <p>
              <Copyright />
            </p>
          </div>
        </div>
      </div>
  );
}
